<template>
  <div>
    <div class="text-xl font-black py-2">3. Growth Strategy</div>

    <!-- Sub section -->
    <div class="pt-2">
      <div class="font-black text-lg py-2">Fee Breakdown</div>
      <div class="flex mb-4">
        <div class="w-full pr-2">
          <div class="py-2">Toggle the left hand panel to represent your current situation, then move them to where you hope to be in the next 12 months.</div>
          <div class="py-2">
            <div v-for="(question, index) in form.questions[page][sectionStart]" :key="index">
              <review-question-component v-model="form.questions[page][sectionStart][index]" :showMandatory="showMandatory"></review-question-component>
            </div>
          </div>
          <office-land-registry-data :officeId="review.office_id" :reviewId="review.id" :income-only="true" />
        </div>
      </div>
    </div>

    <div class="pt-2">
      <div class="font-black text-lg py-2">Fee Strategy</div>
      <div class="flex mb-4">
        <div class="w-full pr-2">
          <div class="py-2">Below are some examples of how other agents have successfully increased their fee using The Guild's offerings.</div>
          <div class="w-full py-2 px-3 border-2 rounded bg-gray-200 border-gray-300">
          </div>
        </div>
      </div>
    </div>

    <hr class="border-b my-8 border-green-600" />
    <div class="pt-2">
      <div v-for="(question2, index2) in form.questions[page][sectionStart+1]" :key="index2">
        <review-question-component v-model="form.questions[page][sectionStart+1][index2]" :showMandatory="showMandatory"></review-question-component>
      </div>
    </div>
    <hr class="border-b my-8 border-green-600" />
    <div class="pt-2">
      <div class="font-black text-lg py-2">Growth plan:</div>
      <div class="py-2">Please populate with any future plans you have for growth:</div>
      <div v-for="(question3, index3) in form.questions[page][sectionStart+2]" :key="index3">
        <review-question-component v-model="form.questions[page][sectionStart+2][index3]" :showMandatory="showMandatory"></review-question-component>
      </div>
    </div>
  </div>
</template>

<script>
import ReviewQuestionComponent from '@/components/AnnualReview/ReviewQuestionComponent'
export default {
  components: { ReviewQuestionComponent },
  props: ['value', 'review', 'page', 'sectionStart', 'showMandatory'],
  data () {
    return {
      form: this.value
    }
  },
  mounted () {
  }
}
</script>
